module.exports = __webpack_public_path__ + "static/img/point_text2.373b70d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/point_text2.png
// module id = q1wE
// module chunks = 1